<template>
  <div
    class="drop-zone"
    style="
      width: 100%;
      height: auto;
      min-height: 100px;
      border: 1px solid;
      padding: 20px;
    "
    @dragover="dragover"
    @dragleave="dragleave"
    @drop="drop"
  >
    <!-- @dragover="handleDragOver"
                  @drop="handleDrop" -->
    <input
      type="file"
      multiple
      name="file"
      id="fileDragAndDrop"
      class="hidden-input"
      @change="onChange"
      ref="fileDragAndDrop"
      :accept="filesAccepted"
    />
    <label for="fileDragAndDrop" class="file-label">
      <div v-if="isDragging">Release to drop files here.</div>
      <div v-else>Drop files here or <u>click here</u> to upload.</div>
    </label>
  </div>
</template>
<script>
import { uploadFile } from "../../../lib/common/uploadPhotos.js";
import { mapMutations } from "vuex";
import { FILE_UPLOAD_EXT_FILES } from "@/upload_file_ext";

export default {
  name: "DragAndDropFiles",
  props: {
    filesAccepted: { type: String, default: FILE_UPLOAD_EXT_FILES },
    maxNumberFilesAccepted: { type: Number, default: null },
  },
  data() {
    return {
      parentId: 0,
      parentType: "service_repair",
      upload_file_type: 6,
      files: [],
      isDragging: false,
    };
  },
  methods: {
    ...mapMutations(["showMessage"]),

    async onChange() {
      this.files = [...this.$refs.fileDragAndDrop.files];

      // check if the max number files accepted is not null and files.length is greater than max number files accepted then cancel process
      if (
        this.maxNumberFilesAccepted &&
        this.files.length > this.maxNumberFilesAccepted
      ) {
        this.showMessage({
          message:
            "Max number of files accepted is:" + this.maxNumberFilesAccepted,
          type: "danger",
          show: true,
        });
        this.$refs["fileDragAndDrop"].value = null;
        return;
      }

      for (let i = 0; i < this.files.length; i++) {
        var type = this.files[i].type.split("/")[1];

        // check if the files get is NOT thesame extension in declared extension type
        if (!this.filesAccepted.includes(type)) {
          this.showMessage({
            message:
              "There are files that is not accepted, files selected: " + type,
            type: "danger",
            show: true,
          });
          this.$refs["fileDragAndDrop"].value = null;
          return;
        }

        const file = this.files[i]; //this is the file
        const data = {
          parentId: this.parentId,
          parentType: this.parentType,
          upload_file_type: this.upload_file_type,
          upload_file: file,
        };
        const items = await uploadFile(data);
        this.$emit("append-files", items);
        //   emit here
      }

      this.$refs["fileDragAndDrop"].value = null;
    },
    dragover(e) {
      e.preventDefault();
      // e.dataTransfer.effectAllowed = "all";
      // e.dataTransfer.dropEffect = "move";
      e.dataTransfer.dropEffect = "copy";
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.fileDragAndDrop.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
  },
};
</script>
